import { OnoffswitchComponent } from './onoffswitch/onoffswitch.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PanelSwitchComponent, PanelComponent } from '@app/modules/shared/panel-switch/panel-switch.component';
import { GoogleplaceDirective } from '@app/directives/googleplace';
import { InputSwitchComponent } from './input-switch/input-switch.component';
import { InputCheckComponent } from './input-check/input-check.component';
import { PanelSwitch2Component, Panel2Component } from '@app/modules/shared/panel-switch2/panel-switch2.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CollapseModule,
    BsDropdownModule.forRoot()
  ],
  declarations: [
    PanelSwitchComponent,
    PanelComponent,
    Panel2Component,
    PanelSwitch2Component,
    OnoffswitchComponent,
    GoogleplaceDirective,
    InputSwitchComponent,
    InputCheckComponent
  ],
  exports: [
    PanelSwitchComponent,
    PanelComponent,
    Panel2Component,
    PanelSwitch2Component,
    OnoffswitchComponent,
    GoogleplaceDirective,
    InputSwitchComponent,
    InputCheckComponent
  ]
})
export class SharedModule { }
